<div class="card">
  <div class="card-body">
    <div class="d-flex justify-content-between flex-wrap">
      <div class="d-flex flex-column">
        <p class="h4 m-0">Espaços</p>
        <p class="p text-secondary">
          Configure espaços exclusivos como camarotes e áreas VIP. Cada espaço possui consumação inclusa.
        </p>
      </div>
    </div>

    <div class="mt-3">
      <div class="d-flex flex-column gap-2">
        @if (spaces.length > 0) {
          <div class="container-spaces">
            @for (space of spaces; track space; let i = $index) {
              <div class="card card-space">
                <div class="card-body p-2 d-flex flex-column justify-content-between">
                  <div class="p-2">
                    <div class="d-flex align-items-center justify-content-between w-100">
                      <p class="h6">{{ space.title }}</p>
                      @if (space.id) {
                        <p class="p text-secondary m-0">#{{ space.id }}</p>
                      }
                    </div>
                    <p class="p text-secondary space-description">{{ space.description }}</p>

                    <div class="d-flex align-items-center justify-content-between w-100">
                      <p class="p" style="font-weight: bold">Valor final</p>
                      <p class="p text-secondary">{{ getFinalPrice(space.price, space.consumption) | currency: "BRL" }}</p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between w-100">
                      <p class="p" style="font-weight: bold">Consumação</p>
                      <p class="p text-secondary">{{ space.consumption | currency: "BRL" }}</p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between w-100">
                      <p class="p" style="font-weight: bold">Quantidade de ingressos</p>
                      <p class="p text-secondary">{{ space.quantity }}</p>
                    </div>

                    <div class="d-flex align-items-center gap-2 mt-2" title="Início das vendas">
                      <p class="p" style="font-weight: bold">Início das vendas</p>
                      <p class="p text-secondary">{{ space.sale_start | date: "short" }}</p>
                    </div>
                    <div class="d-flex align-items-center gap-2" title="Fim das vendas">
                      <p class="p" style="font-weight: bold">Fim das vendas</p>
                      <p class="p text-secondary">{{ space.sale_end | date: "short" }}</p>
                    </div>
                  </div>

                  <div class="d-flex w-100 align-items-center justify-content-center">
                    <app-button
                      title="Editar espaço"
                      icon="pi pi-pen-to-square"
                      styleType="clean"
                      (btnClick)="openSpaceModal(space)">
                      Editar
                    </app-button>
                    @if (!space.id || !space.sold_quantity) {
                      <app-button
                        title="Remover espaço"
                        icon="pi pi-trash"
                        styleType="clean"
                        (btnClick)="removeSpace(space)">
                        Excluir
                      </app-button>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        } @else {
          <p class="p text-secondary">
            Nenhum espaço adicionado. Espaços são opcionais e ideais para camarotes, áreas VIP e lounges.
          </p>
        }

        <div class="p-3">
          <app-button icon="pi pi-plus" styleType="secondary" (btnClick)="openSpaceModal()"> Novo espaço </app-button>
        </div>
      </div>
    </div>
  </div>
</div>
